import { FormattedMessage } from 'react-intl';
import WaitingUI from '~/view/ui/components/Waiting';
import translationsUI from '~/view/ui/translationUI';
import React, { createContext, useState } from 'react';
import translationsComponents from '~/view/containers/translationsComponents';

export const RootLoadingContext = createContext(undefined);

export function LoadingProvider(props) {
  const [loadingState, setloadingState] = useState({
    state: false,
    isOffline: false,
    defaultMess: <FormattedMessage {...translationsUI.PAVE_PROCESS_MESSAGE} />,
    isReceiveComponent: false,
    reportChecking: false,
    receiveMessage: '',
    inFlowFlag: true,
    currentDnAView: (
      <FormattedMessage
        {...translationsComponents.DISCLOSURES_ANNOUNCEMENT_1}
      />
    ),
    isSkipDnA: {
      both: true,
      disclosures: true,
      announcement: true,
      announSubmmited: false,
    },
    activeList: [true, false, false],
    skipCaptureList: [],
  });

  return (
    <RootLoadingContext.Provider value={{ loadingState, setloadingState }}>
      {props.children}
      {loadingState.state && <WaitingUI loadingState={loadingState} />}
    </RootLoadingContext.Provider>
  );
}
